/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PurchaseOrderSearchFields {
    PURCHASE_ORDER_NUMBER = 'purchase_order_number',
}
